export default "__VITE_ASSET__CwciMtNy__"